import React from "react";

export const IconCheck = ({ color = "#36F99F", size = 20, dataTip }) => {
  return (
    <svg
      id="icon-check"
      data-tip={dataTip}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
    >
      <rect width="20" height="20" rx="10" fill={color} />
      <path
        d="M13.33 7L8.29062 12.0394L6 9.74875"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
